import React from "react";
import { AvailRoleToken } from "../cards/DraggableShiftCanvasser";
import { CANVASSER_STATUS_COLORS } from "../../utils/schedulerUtils";

export default class CanvasserFilters extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      //canvasser filters
      showFilters: false,
      showAssignedCanvassers: true,
      availableCanvasserStatuses: [
        "checked_in",
        "not_checked_in",
        "unscheduled",
      ],
      displayedCanvasserStatuses: [
        "checked_in",
        "not_checked_in",
        "unscheduled",
      ],
      // eslint-disable-next-line react/prop-types
      abilities: Object.keys(props.availableAbilities).reduce((acc, key) => {
        acc[key] = true; // false to hide
        return acc;
      }, {}),
    };

    this.colorClassMapping = CANVASSER_STATUS_COLORS;
  }

  _handleLegendCheckboxToggle = (status) => {
    // check if status is in display
    let new_displayed_statuses;
    if (this.state.displayedCanvasserStatuses.includes(status)) {
      new_displayed_statuses = this.state.displayedCanvasserStatuses.filter(
        (d) => d !== status
      );
    } else {
      new_displayed_statuses = [
        ...this.state.displayedCanvasserStatuses,
        status,
      ];
    }

    this.setState({ displayedCanvasserStatuses: new_displayed_statuses }, () =>
      this.handleChange()
    );
  };

  handleAbilityFilter = (abilityId) => {
    let newState = { ...this.state.abilities };
    newState[abilityId] = !newState[abilityId];
    this.setState({ abilities: newState }, () => this.handleChange());
  };

  handleChange() {
    this.props.handleFilterUpdate(
      this.state.displayedCanvasserStatuses,
      this.state.abilities,
      this.state.showAssignedCanvassers
    );
  }

  toggleFilters() {
    this.setState({ showFilters: !this.state.showFilters });
  }

  render() {
    return (
      <div style={{ fontSize: "11px" }}>
        <div
          className={"button button-clear mb-0 px-0 primary-text"}
          onClick={() => this.toggleFilters()}
        >
          {this.state.showFilters ? "Hide Filters" : "Show Filters"}
        </div>

        <div
          className={"wrapper"}
          style={{ display: this.state.showFilters ? "block" : "none" }}
        >
          {this.state.availableCanvasserStatuses.map((d) => {
            return (
              <div
                className={"grid flex-start spacing"}
                onClick={() => this._handleLegendCheckboxToggle(d)}
                key={d}
                style={{ marginTop: 4 }}
              >
                <input
                  type="checkbox"
                  checked={this.state.displayedCanvasserStatuses.includes(d)}
                  style={{
                    marginBottom: 0,
                    marginTop: 0,
                    accentColor: this.colorClassMapping[d].color,
                  }}
                />
                <div className={"grid-item"}>
                  {d.charAt(0).toUpperCase() + d.slice(1).replace(/_/g, " ")}
                </div>
              </div>
            );
          })}

          <div className={"divider"}></div>

          <div
            className={"grid flex-start spacing"}
            onClick={() =>
              this.setState(
                {
                  showAssignedCanvassers: !this.state.showAssignedCanvassers,
                },
                () => this.handleChange()
              )
            }
          >
            <input
              type="checkbox"
              value={this.state.showAssignedCanvassers}
              checked={this.state.showAssignedCanvassers}
              style={{ marginBottom: 0, marginTop: 0 }}
            />
            <div className={"grid-item"}>Show Assigned</div>
          </div>

          <div className={"divider"}></div>

          {Object.keys(this.state.abilities).map((abilityName) => {
            return (
              <div
                className={"grid flex-start spacing"}
                style={{ margin: "8px 0" }}
                key={`role-${abilityName}`}
                onClick={() => this.handleAbilityFilter(abilityName)}
              >
                <input
                  type="checkbox"
                  value={abilityName}
                  style={{ marginBottom: 0, marginTop: 0 }}
                  checked={this.state.abilities[abilityName]}
                />
                <AvailRoleToken role={abilityName} />
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
